import React, { useEffect } from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'
import '@/styles/animations.scss'

interface ModalProps {
  className?: string
  modalTitle?: string
  noneCrossMark?: boolean
  search?: boolean
  animation?: string
  onClose: () => void
  children?: React.ReactNode
  fixedButton?: React.ReactNode
  buttonCloseOnCorner?: boolean
}

const Modal: React.FC<ModalProps> = ({
  className,
  modalTitle,
  noneCrossMark = false,
  search = false,
  animation = 'fade',
  onClose,
  children,
  fixedButton,
  buttonCloseOnCorner = false,
}) => {
  useEffect(() => {
    // Modal表示時に#main-containerにクラスを追加
    const mainContainer = document.getElementById('main-container')
    if (mainContainer) {
      mainContainer.classList.add('modal-active')
    }

    // クリーンアップ: Modal非表示時にクラスを削除
    return () => {
      const mainContainer = document.getElementById('main-container')
      if (mainContainer) {
        mainContainer.classList.remove('modal-active')
      }
    }
  }, [])

  // アニメーションクラスを決定
  const getAnimationClass = () => {
    if (!animation || animation === 'none') return ''
    // グローバルクラス名として直接使用
    return `animation${animation.charAt(0).toUpperCase() + animation.slice(1)}`
  }

  return (
    <div
      className={clsx(
        styles.modalWindow,
        { [styles.search]: search },
        className && styles[className],
        getAnimationClass(),
      )}
    >
      <div
        className={clsx(styles.modalContent, {
          [styles.noneCloss]: noneCrossMark || buttonCloseOnCorner,
        })}
      >
        {!noneCrossMark && (
          <span
            className={clsx(styles.buttonClose, {
              [styles.onCorner]: buttonCloseOnCorner,
            })}
            onClick={onClose}
          />
        )}
        {modalTitle && <div className={styles.modalTitle}>{modalTitle}</div>}
        {children}
      </div>
      {fixedButton}
    </div>
  )
}

export default Modal
